import React from "react";
import { Star, GripVertical } from "lucide-react";
import { Link } from "react-router";
import { formatDate } from "../helpers/dates";

interface FiringCardProps {
  id?: string;
  name?: string;
  date?: number;
  favourite?: boolean;
  index: number;
  hideIndex?: boolean;
  to?: string;
  showHandle?: boolean;
  isDragging?: boolean;
  draggableProps?: any;
  dragHandleProps?: any;
  [key: string]: any;
}

const FiringCard = React.forwardRef<HTMLDivElement, FiringCardProps>((props, ref) => {
  const {
    name,
    date,
    favourite,
    index,
    hideIndex,
    to,
    showHandle = false,
    isDragging,
    draggableProps,
    dragHandleProps,
  } = props;

  const label = name || "Untitled firing";
  const dateText = date ? formatDate(date) : "planned";

  const body = (
    <div className="flex-1 flex items-center justify-between gap-3 min-w-0 px-3.5 py-3 text-sm cursor-pointer">
      <div className="flex items-center gap-2 min-w-0">
        {!hideIndex && (
          <span className="font-mono text-muted-foreground tabular-nums">{index + 1}.</span>
        )}
        <span className="font-medium truncate">{label}</span>
        {favourite && (
          <Star className="h-3.5 w-3.5 fill-yellow-400 text-yellow-400 shrink-0" />
        )}
      </div>
      <span className="text-xs text-muted-foreground shrink-0">{dateText}</span>
    </div>
  );

  return (
    <div
      ref={ref}
      {...draggableProps}
      className="flex items-stretch rounded-lg border border-border bg-card hover:bg-muted transition-colors"
      style={{
        background: isDragging ? "var(--color-muted)" : undefined,
        ...draggableProps?.style,
      }}
    >
      {showHandle && (
        <div
          {...dragHandleProps}
          className="flex items-center cursor-grab text-muted-foreground hover:text-foreground pl-2 pr-1 shrink-0"
        >
          <GripVertical className="h-4 w-4" />
        </div>
      )}
      {to ? (
        <Link to={to} className="flex-1 min-w-0 flex">
          {body}
        </Link>
      ) : (
        body
      )}
    </div>
  );
});

FiringCard.displayName = "FiringCard";

export default FiringCard;
